export const About = () => (
  <section
    id="om"
    aria-labelledby="om-title"
    className="relative bg-paper"
    data-testid="om-section"
  >
    <div className="relative overflow-hidden">
      <img
        src="/images/roof-approved.webp"
        alt=""
        className="block h-[760px] w-full object-cover object-[58%_center] sm:h-[820px] md:h-[720px] md:object-cover md:object-[58%_56%] lg:h-[680px] xl:h-[720px]"
        data-testid="om-image"
      />

      <div className="absolute left-5 right-5 top-12 z-20 sm:left-8 sm:right-8 sm:top-16 md:left-[17%] md:right-auto md:top-[12%] md:w-[46%] md:max-w-[620px]">
        <h2
          id="om-title"
          className="font-display text-[2.8rem] font-normal leading-[0.98] tracking-tight text-ink sm:text-[3.6rem] md:text-[clamp(2.8rem,3.7vw,4.2rem)]"
        >
          Erfarenhet som{" "}
          <span className="italic text-moss">märks i arbetet.</span>
        </h2>

        <div className="mt-7 max-w-[620px] space-y-5 font-display text-[1.05rem] leading-[1.5] text-ink/85 sm:text-[1.12rem] md:mt-7 md:text-[clamp(0.98rem,1.15vw,1.16rem)]">
          <p>
            Folkare Bygg grundades 2008 och har sedan dess varit en pålitlig
            aktör i Folkarebygden, med Lars Odeling som ägare och din personliga
            kontakt.
          </p>
          <p>
            Lars har yrkesbevis och har själv arbetat som hantverkare i flera år.
            Han har dessutom studerat byggplanering och arbetsledning vid
            yrkesteknisk högskola och har mer än tio års erfarenhet som behörig
            yrkeslärare inom bygg.
          </p>
        </div>

        <p
          className="mt-7 max-w-[540px] border-l-[3px] border-moss pl-5 font-display text-xl italic leading-snug text-ink sm:text-2xl md:mt-7 md:text-[clamp(1.15rem,1.45vw,1.5rem)]"
          data-testid="om-signature"
        >
          Ett litet, flexibelt byggföretag –<br className="hidden sm:block" />
          med Lars som din kontakt.
        </p>
      </div>

      <div
        className="pointer-events-none absolute inset-x-0 top-0 z-10 h-[70px] sm:h-[90px] lg:h-[100px]"
        style={{
          background:
            "linear-gradient(180deg, rgba(251,249,245,1) 0%, rgba(251,249,245,0.68) 30%, rgba(251,249,245,0.22) 68%, rgba(251,249,245,0) 100%)",
        }}
        aria-hidden="true"
      />

      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-[110px] sm:h-[130px] lg:h-[130px]"
        style={{
          background:
            "linear-gradient(180deg, rgba(251,249,245,0) 0%, rgba(251,249,245,0.18) 28%, rgba(251,249,245,0.52) 58%, rgba(251,249,245,0.82) 80%, rgba(251,249,245,1) 100%)",
        }}
        aria-hidden="true"
      />
    </div>
  </section>
);
